import Column from '@components/Column';
// import Tooltip from '@components/Tooltip';

import PickIcon from './PickIcon';
import styles from './styles.module.scss';

interface Props {
    isScrolling: boolean;
}

function PickButton({ isScrolling }:Props) {
    return (
        <Column align='center' spacing={6}
            className={styles.container}
            style={{ opacity: isScrolling ? 0.8 : 1 }} >
            <PickIcon/>
            <button className={styles.button}>
                골라담기
            </button>
        </Column>
    );
    /*
  return (
        <Link href={{ pathname: '/items', query: { type: 'myMenu' } }}
              className={styles.wrapper} >
            <Column align='center' spacing={6}
                    className={styles.container}
                    style={{ opacity: isScrolling ? 0.8 : 1 }} >
                <PickIcon/>
                <button className={styles.button}>
                    골라담기
                </button>
            </Column>
        </Link>
  );

     */
}

export default PickButton;
